import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import Utils from 'utils/Utils';

import useStyles from './styles';

const Logo = ({ className }) => {
    const history = useHistory();
    const { classes, cx } = useStyles();
    const handleClick = useCallback(() => {
        history.push(location.pathname + location.search === '/search' ? '/' : '/search');
    }, [history]);

    return (
        <picture>
            <source srcSet={Utils.getImage('logo_small')} media="(max-width: 960px)" />
            <source srcSet={Utils.getImage('logo')} media="(min-width: 960px)" />
            <img
                onClick={handleClick}
                className={cx(classes.logo, className)}
                src={Utils.getImage('logo')}
                alt="Logo"
            />
        </picture>
    );
};

Logo.propTypes = {
    className: PropTypes.string
};

export default Logo;
